import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { api_routes } from '@app/consts';
import { EnvironmentService } from '@app/core/services/environment.service';
import { Observable } from 'rxjs';
import { TimeoffCalculationEntriesReportApiResponse } from '../models/timeoff-calculation-entries-report.model';

const headers = new HttpHeaders({
  'Content-Type': 'application/json',
});

@Injectable({
  providedIn: 'root'
})
export class TimeoffCalculationEntiresReportService {

  constructor(
    private http: HttpClient,
    private envService: EnvironmentService
  ) { }

  getReportData(employeeId: string, timeoffTypeId: string): Observable<TimeoffCalculationEntriesReportApiResponse[]> {
    const url = `${this.envService.env.apiUrl}/${api_routes.REPORTS}/${api_routes.PREDEFINED}/TimeoffCalculationEntries/${employeeId}/${timeoffTypeId}`;
    return this.http.get<TimeoffCalculationEntriesReportApiResponse[]>(url, { headers });
  }
}
